import { XMLNode } from "../../fileToolbar/fileToolbarTypes";
import { getDataReader, RPWDataReader } from "../../livedataFuncs";
import { store } from "../../redux/store";
import { GuarantorType, PriorOwnerType, PurchaserType, VendorType } from "../../SideDrawer/sideTypes";
import { TransfereeInfo } from "./similarNameTypes";

export function getDefectNodesAsArray(defectNodes: Array<ajaxslt.XNode>): Array<XMLNode> {
    let retArr = [];
    for (let i = 0; i < defectNodes.length; i++) {
        const type = defectNodes[i].getAttribute('type');
        if (!type || type.startsWith('21_')) {
            retArr.push(defectNodes[i]);
        }
    }
    return retArr;
}

export function getTransfereeNodes(): Array<PurchaserType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let transfereeNodes = DataReaderObj.getBuyerPeopleInfo();
    transfereeNodes.map((ele) => {
        nameArray.push(
            ele
        )
    })
    return nameArray;
}

export function getTransferorNodes(): Array<VendorType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let transfereeNodes = DataReaderObj.getSellerPeopleInfo();
    transfereeNodes.map((ele) => {
        nameArray.push(
            ele
        )
    })
    return nameArray;
}

export function getGuarantorInfo(): Array<GuarantorType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let nameArray = [];
    let guarantorNodes = DataReaderObj.getGuarantorInfo();
    for (let i = 0; i < guarantorNodes.length; i++) {
        nameArray.push({
            Name: guarantorNodes[i].getAttribute('Name'),
        })
    }
    return nameArray;
}

export function cleanDefectNodes(dataRoot): void {
    let defectNodes = dataRoot.selectNodes('Defect');
    for (let i = 0; i < defectNodes.length; i++) {
        let data = defectNodes[i].selectSingleNode('Data');
        let type = defectNodes[i].getAttribute("type");
        if (type === '21' || type?.indexOf('21_') === 0) {
            let AgainstReal = data?.getAttribute('AgainstReal');
            if (AgainstReal === null || AgainstReal === undefined || AgainstReal === '') {
                if (i !== (defectNodes.length - 1)) {
                    dataRoot.removeChild(defectNodes[i]);
                }
            }
        }
    }
}

export function getPriorOwnersInfo(): Array<PriorOwnerType> {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let priorOwnerNodes = DataReaderObj.getPriorOwnerInfo();
    return priorOwnerNodes;
}

export function getTransfereeInfo(): TransfereeInfo | null {
    let dataRoot = store?.getState()?.currentNavigation.livedataRootContainer.dataRoot;
    let DataReaderObj: RPWDataReader;
    DataReaderObj = getDataReader(dataRoot);
    let filePSM = DataReaderObj.getPSM();
    if (filePSM === 'P') {
        return {code: '21_3', summary: 'Buyer', name: 'Buyer'};
    } else if (filePSM === 'M') {
        return {code: '21_4', summary: 'Mortgagor', name: 'Mortgagor'};
    }
    return null;
}

export type AgainstOption = { value: string; label: string };

export function getAgainstOptions(psm: string, appcode: string): AgainstOption[] {
    const selectOne: AgainstOption = { value: "", label: "Select One" };

    if (appcode === 'MB') {
        return [selectOne, { value: "21_6", label: "Debtor" }];
    }

    if (psm === 'M') {
        return [
            selectOne,
            { value: "21_4", label: "Mortgagor" },
            { value: "21_1", label: "Guarantor" },
            { value: "21_2", label: "Prior Owner" },
            { value: "21_5", label: "Other" },
        ];
    }

    return [
        selectOne,
        { value: "21_3", label: "Purchaser" },
        { value: "21_4", label: "Reg. Owner" },
        { value: "21_1", label: "Guarantor" },
        { value: "21_2", label: "Prior Owner" },
        { value: "21_5", label: "Other" },
    ];
}

export function getSummaryForType(type: string): string {
    switch (type) {
        case '21_3': return 'Purchaser';
        case '21_4': return 'Registered Owner';
        case '21_1': return 'Guarantor';
        case '21_2': return 'Prior Owner';
        case '21_5': return 'Other Executions Issues';
        default: return '';
    }
}
